// ORIVANA Wellness Products Data
// Organized by Health Concern/Condition

export const wellnessCategories = [
  {
    id: 'immunity-care',
    name: 'Immunity Care',
    description: 'Strengthen your natural defenses with time-tested Ayurvedic formulations',
    icon: 'Shield',
    color: '#4CAF50'
  },
  {
    id: 'digestive-health',
    name: 'Digestive Health',
    description: 'Support gut health, digestion and natural detoxification',
    icon: 'Leaf',
    color: '#8BC34A'
  },
  {
    id: 'stress-sleep',
    name: 'Stress & Sleep',
    description: 'Calm the mind, reduce stress and promote restful sleep',
    icon: 'Moon',
    color: '#7E57C2'
  },
  {
    id: 'energy-vitality',
    name: 'Energy & Vitality',
    description: 'Boost stamina, endurance and overall vitality naturally',
    icon: 'Zap',
    color: '#FF9800'
  },
  {
    id: 'womens-wellness',
    name: "Women's Wellness",
    description: 'Support hormonal balance, reproductive health and prenatal nutrition',
    icon: 'Heart',
    color: '#E91E63'
  },
  {
    id: 'mens-wellness',
    name: "Men's Wellness",
    description: 'Enhance strength, stamina and support prostate health',
    icon: 'Dumbbell',
    color: '#2196F3'
  },
  {
    id: 'joint-mobility',
    name: 'Joint & Mobility',
    description: 'Support healthy joints, flexibility and comfortable movement',
    icon: 'Activity',
    color: '#00BCD4'
  },
  {
    id: 'heart-health',
    name: 'Heart Health',
    description: 'Promote cardiovascular wellness and healthy circulation',
    icon: 'HeartPulse',
    color: '#F44336'
  },
  {
    id: 'herbal-teas',
    name: 'Herbal Teas',
    description: 'Premium Tulsi and Ayurvedic tea blends for daily wellness',
    icon: 'Coffee',
    color: '#795548'
  }
];

export const wellnessProducts = [
  // IMMUNITY CARE
  {
    id: 'ashwagandha-capsules',
    name: 'Ashwagandha Capsules',
    slug: 'ashwagandha-capsules',
    category: 'immunity-care',
    tagline: 'Adaptogenic Stress Relief & Immune Support',
    description: 'ORIVANA Ashwagandha Capsules are formulated with premium KSM-66 Ashwagandha root extract, known for its adaptogenic properties. This ancient Ayurvedic herb helps the body adapt to stress, supports immune function, and promotes overall vitality.',
    benefits: [
      'Reduces cortisol and stress levels',
      'Supports healthy immune response',
      'Enhances energy and stamina',
      'Promotes restful sleep',
      'Supports cognitive function'
    ],
    ingredients: ['Organic Ashwagandha Root Extract (KSM-66)', 'Vegetable Cellulose Capsule', 'Organic Rice Flour'],
    usage: 'Take 1-2 capsules daily with water, preferably with meals. For best results, use consistently for 8-12 weeks.',
    specifications: {
      'Pack Size': '60 Vegetarian Capsules',
      'Serving Size': '1 Capsule',
      'Extract Strength': '500mg per capsule',
      'Certification': 'USDA Organic, Non-GMO'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/1946ced92d6cb65c93446ea38c391efe4d824afa3caf38824635c08e098fb4ce.png',
    featured: true,
    isBestSeller: true
  },
  {
    id: 'tulsi-immunity-blend',
    name: 'Tulsi Immunity Blend',
    slug: 'tulsi-immunity-blend',
    category: 'immunity-care',
    tagline: 'Triple Tulsi Power for Daily Defense',
    description: 'A powerful blend of three sacred Tulsi varieties - Rama, Krishna, and Vana Tulsi. This immunity-boosting formula provides comprehensive support for respiratory health, stress reduction, and natural detoxification.',
    benefits: [
      'Supports respiratory health',
      'Natural adaptogenic properties',
      'Rich in antioxidants',
      'Promotes natural detoxification',
      'Supports healthy inflammation response'
    ],
    ingredients: ['Rama Tulsi Leaf', 'Krishna Tulsi Leaf', 'Vana Tulsi Leaf'],
    usage: 'Steep 1 tea bag in hot water for 5-7 minutes. Enjoy 2-3 cups daily for optimal benefits.',
    specifications: {
      'Pack Size': '25 Tea Bags',
      'Type': 'Caffeine-Free Herbal Infusion',
      'Origin': 'Certified Organic Farms, India',
      'Certification': 'USDA Organic'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/c0be8f7cbc1b39a4c5726d30595f316b8700b79c85729ffa2b7c982e9e03026f.png',
    featured: true
  },
  {
    id: 'amalaki-vitamin-c',
    name: 'Amalaki Vitamin C',
    slug: 'amalaki-vitamin-c',
    category: 'immunity-care',
    tagline: 'Natural Vitamin C from Indian Gooseberry',
    description: 'ORIVANA Amalaki capsules provide natural Vitamin C from organic Indian Gooseberry (Amla). This superfruit is revered in Ayurveda for its powerful antioxidant properties and immune-supporting benefits.',
    benefits: [
      'Natural source of Vitamin C',
      'Powerful antioxidant protection',
      'Supports collagen production',
      'Promotes healthy skin and hair',
      'Aids iron absorption'
    ],
    ingredients: ['Organic Amalaki Fruit Extract', 'Vegetable Cellulose Capsule'],
    usage: 'Take 2 capsules daily with water, preferably in the morning.',
    specifications: {
      'Pack Size': '60 Vegetarian Capsules',
      'Vitamin C Content': '250mg per serving',
      'Extraction': 'Whole Fruit Extract',
      'Certification': 'USDA Organic, Vegan'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/6844c29955c4fa4fc7762243b99ca20ad267952c80cb4d0d4271aa150117f3eb.png',
    featured: false
  },
  {
    id: 'giloy-capsules',
    name: 'Giloy Capsules',
    slug: 'giloy-capsules',
    category: 'immunity-care',
    tagline: 'The Root of Immortality',
    description: 'Giloy (Tinospora cordifolia), known as "Amrita" or the root of immortality in Ayurveda, is a powerful immunomodulator. ORIVANA Giloy capsules support healthy immune function and help maintain overall wellness.',
    benefits: [
      'Powerful immunomodulatory herb',
      'Supports healthy fever response',
      'Promotes detoxification',
      'Antioxidant properties',
      'Supports liver health'
    ],
    ingredients: ['Organic Giloy Stem Extract', 'Vegetable Cellulose Capsule'],
    usage: 'Take 1-2 capsules twice daily with water.',
    specifications: {
      'Pack Size': '60 Vegetarian Capsules',
      'Extract Ratio': '10:1',
      'Part Used': 'Stem',
      'Certification': 'USDA Organic'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/2a4f67bf6249b413e6f44ad4de0fe22031c7ba217344a36c2728489e7cead041.png',
    featured: false
  },
  {
    id: 'chyawanprash',
    name: 'Chyawanprash',
    slug: 'chyawanprash',
    category: 'immunity-care',
    tagline: 'Ancient Ayurvedic Immunity Jam',
    description: 'ORIVANA Chyawanprash is a traditional Ayurvedic formulation made with over 40 herbs and botanicals, with Amla as the key ingredient. This time-tested recipe supports immunity, vitality, and overall rejuvenation.',
    benefits: [
      'Comprehensive immunity support',
      'Rich in natural Vitamin C',
      'Promotes respiratory health',
      'Supports energy and vitality',
      'Rejuvenating tonic for all ages'
    ],
    ingredients: ['Amla', 'Ashwagandha', 'Pippali', 'Guduchi', 'Shatavari', 'Organic Honey', 'Ghee', '35+ Ayurvedic Herbs'],
    usage: 'Take 1-2 teaspoons daily, directly or mixed with warm milk.',
    specifications: {
      'Pack Size': '500g Glass Jar',
      'Form': 'Herbal Jam',
      'Suitable For': 'All ages above 3 years',
      'Certification': 'GMP Certified'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/235897c9cad17017da4b47400cd8a1bca6ad11d9427edc74c3e364a641a0216f.png',
    featured: true,
    isNewArrival: true
  },
  {
    id: 'amla-powder',
    name: 'Amla Powder',
    slug: 'amla-powder',
    category: 'immunity-care',
    tagline: 'Pure Indian Gooseberry Superfood',
    description: 'ORIVANA Amla Powder is made from premium organic Indian Gooseberry (Emblica officinalis), one of the richest natural sources of Vitamin C. This versatile superfood supports immunity, digestion, and healthy hair and skin from the inside out.',
    benefits: [
      'One of the richest natural sources of Vitamin C',
      'Powerful antioxidant protection',
      'Supports healthy hair growth and skin radiance',
      'Promotes digestive health and metabolism',
      'Helps maintain healthy blood sugar levels'
    ],
    ingredients: ['100% Organic Amla Fruit Powder'],
    usage: 'Mix 1 teaspoon in water, juice, or smoothie. Can also be mixed with honey or added to food. Take 1-2 times daily.',
    specifications: {
      'Pack Size': '200g Resealable Pouch',
      'Form': 'Fine Powder',
      'Processing': 'Low-temperature dried',
      'Certification': 'USDA Organic'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/1371e427a4bd618cf21f7fc008a1665a89cd5967ef283e4c231740171d8b30ba.png',
    featured: false,
    isBestSeller: true
  },

  // DIGESTIVE HEALTH
  {
    id: 'triphala-capsules',
    name: 'Triphala Capsules',
    slug: 'triphala-capsules',
    category: 'digestive-health',
    tagline: 'Three Fruits for Complete Digestive Support',
    description: 'Triphala, the legendary Ayurvedic formula combining Amalaki, Bibhitaki, and Haritaki, provides gentle yet effective digestive support. ORIVANA Triphala promotes regularity, detoxification, and overall digestive wellness.',
    benefits: [
      'Supports healthy digestion',
      'Gentle colon cleansing',
      'Promotes regular elimination',
      'Rich in antioxidants',
      'Supports nutrient absorption'
    ],
    ingredients: ['Organic Amalaki Fruit', 'Organic Bibhitaki Fruit', 'Organic Haritaki Fruit'],
    usage: 'Take 2 capsules before bedtime with warm water for gentle overnight cleansing.',
    specifications: {
      'Pack Size': '60 Vegetarian Capsules',
      'Ratio': 'Equal parts of all three fruits',
      'Form': 'Full Spectrum Extract',
      'Certification': 'USDA Organic, Non-GMO'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/053f3445a741ab472408ddd088504aa81bfb9814f6869cc50a60a5293cf8550a.png',
    featured: true,
    isBestSeller: true
  },
  {
    id: 'psyllium-husk',
    name: 'Psyllium Whole Husk',
    slug: 'psyllium-husk',
    category: 'digestive-health',
    tagline: 'Natural Fiber for Digestive Wellness',
    description: 'ORIVANA Psyllium Husk (Isabgol) is a natural source of soluble fiber that supports digestive health. This gentle bulk-forming fiber promotes regularity and helps maintain healthy cholesterol levels.',
    benefits: [
      'Supports regular bowel movements',
      'Helps maintain healthy cholesterol',
      'Promotes satiety and weight management',
      'Gentle and non-habit forming',
      'Prebiotic fiber for gut health'
    ],
    ingredients: ['100% Organic Psyllium Husk'],
    usage: 'Mix 1-2 teaspoons in a glass of water or juice. Drink immediately. Follow with another glass of water.',
    specifications: {
      'Pack Size': '200g Resealable Pouch',
      'Fiber Content': '85% Soluble Fiber',
      'Origin': 'Gujarat, India',
      'Certification': 'USDA Organic'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/b41c9bfc889c8b1437c9216d8525692eb8bb980a7fd6083c3d9c206f2ed203f2.png',
    featured: false
  },
  {
    id: 'digestive-enzymes',
    name: 'Digestive Enzyme Complex',
    slug: 'digestive-enzymes',
    category: 'digestive-health',
    tagline: 'Plant-Based Enzymes for Optimal Digestion',
    description: 'A comprehensive blend of plant-based digestive enzymes combined with traditional Ayurvedic digestive herbs. Supports the breakdown of proteins, carbohydrates, and fats for improved nutrient absorption.',
    benefits: [
      'Supports complete food breakdown',
      'Reduces bloating and gas',
      'Enhances nutrient absorption',
      'Supports after-meal comfort',
      'Gentle on the stomach'
    ],
    ingredients: ['Amylase', 'Protease', 'Lipase', 'Cellulase', 'Ginger Extract', 'Fennel Extract', 'Peppermint Leaf'],
    usage: 'Take 1 capsule with each main meal.',
    specifications: {
      'Pack Size': '60 Vegetarian Capsules',
      'Type': 'Broad Spectrum Enzyme Blend',
      'Form': 'Delayed Release Capsules',
      'Certification': 'Vegan, Non-GMO'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/e650d5ab7a57d4e38c7ee2cab2e24ede76cc6d3129c4d92aaeb5d0c996985a0e.png',
    featured: false
  },
  {
    id: 'apple-cider-vinegar',
    name: 'Apple Cider Vinegar',
    slug: 'apple-cider-vinegar',
    category: 'digestive-health',
    tagline: 'Raw, Unfiltered with The Mother',
    description: 'ORIVANA Apple Cider Vinegar is raw, unfiltered, and contains "The Mother" - beneficial strands of proteins, enzymes, and friendly bacteria. Made from organic Himalayan apples for superior quality.',
    benefits: [
      'Supports healthy digestion',
      'Helps maintain blood sugar levels',
      'Natural detoxification support',
      'Promotes healthy skin',
      'Supports weight management'
    ],
    ingredients: ['100% Organic Apple Cider Vinegar with Mother'],
    usage: 'Mix 1-2 tablespoons in a glass of water. Consume before meals for digestive support.',
    specifications: {
      'Pack Size': '500ml Glass Bottle',
      'Acidity': '5-6%',
      'Type': 'Raw, Unfiltered, Unpasteurized',
      'Origin': 'Himalayan Apples'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/b2cd5eaa48fc040fcf385f4038f58a1c78dc371028164ef12863b1ca5bc9c608.png',
    featured: true
  },
  {
    id: 'moringa-powder',
    name: 'Moringa Leaf Powder',
    slug: 'moringa-powder',
    category: 'digestive-health',
    tagline: 'The Miracle Tree Superfood',
    description: 'ORIVANA Moringa Powder is made from shade-dried organic Moringa oleifera leaves. This nutrient-dense superfood supports digestion, provides essential vitamins and minerals, and promotes overall wellness.',
    benefits: [
      'Rich in vitamins A, C, and E',
      'Complete plant protein source',
      'Supports healthy blood sugar',
      'Natural anti-inflammatory',
      'Promotes digestive health'
    ],
    ingredients: ['100% Organic Moringa Oleifera Leaf Powder'],
    usage: 'Add 1 teaspoon to smoothies, juices, or food. Start with small amounts and gradually increase.',
    specifications: {
      'Pack Size': '100g Resealable Pouch',
      'Processing': 'Shade-Dried, Stone-Ground',
      'Nutrients': '90+ Nutrients, 46 Antioxidants',
      'Certification': 'USDA Organic'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/49ca333efb2188cb495bcef577fb734c0daac770a7c55ca64f7a67195eda18e0.png',
    featured: false
  },
  {
    id: 'garcinia-cambogia',
    name: 'Garcinia Cambogia',
    slug: 'garcinia-cambogia',
    category: 'digestive-health',
    tagline: 'Natural Weight Management Support',
    description: 'ORIVANA Garcinia Cambogia is derived from the tropical Malabar tamarind fruit, standardized for HCA (Hydroxycitric Acid). This Ayurvedic herb supports healthy weight management by promoting satiety and supporting fat metabolism.',
    benefits: [
      'Supports healthy weight management',
      'Promotes feeling of fullness and satiety',
      'Helps reduce occasional food cravings',
      'Supports healthy fat metabolism',
      'Promotes emotional well-being during weight loss'
    ],
    ingredients: ['Organic Garcinia Cambogia Fruit Extract (60% HCA)', 'Vegetable Cellulose Capsule'],
    usage: 'Take 1-2 capsules 30-60 minutes before meals with a full glass of water. Best results with balanced diet and exercise.',
    specifications: {
      'Pack Size': '60 Vegetarian Capsules',
      'HCA Content': '60% Hydroxycitric Acid',
      'Form': 'Standardized Extract',
      'Certification': 'Non-GMO, GMP Certified'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/bdbb4c2df0dfa38d65fdafe853042f9024edfb3ab3d57fa2cc24134972513fe6.png',
    featured: false,
    isBestSeller: true
  },
  {
    id: 'wheat-grass-powder',
    name: 'Wheat Grass Powder',
    slug: 'wheat-grass-powder',
    category: 'digestive-health',
    tagline: 'Nature\'s Green Detox Superfood',
    description: 'ORIVANA Wheat Grass Powder is made from young, nutrient-rich wheat grass harvested at peak nutrition. This chlorophyll-rich superfood supports natural detoxification, alkalizes the body, and provides a concentrated source of vitamins, minerals, and enzymes.',
    benefits: [
      'Rich in chlorophyll for natural detoxification',
      'Helps alkalize and balance body pH',
      'Supports healthy digestion and elimination',
      'Provides concentrated vitamins A, C, E, K',
      'Contains natural enzymes for nutrient absorption'
    ],
    ingredients: ['100% Organic Wheat Grass Powder'],
    usage: 'Mix 1 teaspoon in water, juice, or smoothie. Best taken on empty stomach in the morning. Start with half serving and gradually increase.',
    specifications: {
      'Pack Size': '100g Resealable Pouch',
      'Form': 'Fine Green Powder',
      'Processing': 'Low-temperature dried at harvest peak',
      'Certification': 'USDA Organic'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/c553223cc040cbe3f51458fb523c6079c3597d7e70c961c9592bdd530096c1db.png',
    featured: false,
    isNewArrival: true
  },

  // STRESS & SLEEP
  {
    id: 'sleep-support',
    name: 'Sleep Support Formula',
    slug: 'sleep-support',
    category: 'stress-sleep',
    tagline: 'Natural Support for Restful Sleep',
    description: 'A synergistic blend of Ayurvedic herbs traditionally used to promote restful sleep. Combining Ashwagandha, Brahmi, and Jatamansi, this formula calms the mind and supports healthy sleep patterns.',
    benefits: [
      'Promotes restful, quality sleep',
      'Calms racing thoughts',
      'Non-habit forming formula',
      'Supports natural sleep cycles',
      'Wake up refreshed'
    ],
    ingredients: ['Ashwagandha Root', 'Brahmi Leaf', 'Jatamansi Root', 'Tagara Root', 'Chamomile Flower'],
    usage: 'Take 2 capsules 30-60 minutes before bedtime with warm water or milk.',
    specifications: {
      'Pack Size': '60 Vegetarian Capsules',
      'Type': 'Non-Habit Forming',
      'Form': 'Full Spectrum Herbal Blend',
      'Certification': 'GMP Certified'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/c5a9343356ac54ea45f514dd7aa42e98f87b8f113da4a2102c01d55bb0a66cd6.png',
    featured: true,
    isNewArrival: true
  },
  {
    id: 'brahmi-capsules',
    name: 'Brahmi Capsules',
    slug: 'brahmi-capsules',
    category: 'stress-sleep',
    tagline: 'Ayurvedic Brain Tonic',
    description: 'Brahmi (Bacopa monnieri) is revered in Ayurveda as a premier brain tonic. ORIVANA Brahmi capsules support memory, focus, and cognitive function while promoting a calm, clear mind.',
    benefits: [
      'Supports memory and recall',
      'Enhances focus and concentration',
      'Promotes mental clarity',
      'Calms anxiety and stress',
      'Supports healthy brain aging'
    ],
    ingredients: ['Organic Brahmi Whole Plant Extract', 'Vegetable Cellulose Capsule'],
    usage: 'Take 1-2 capsules twice daily with meals.',
    specifications: {
      'Pack Size': '60 Vegetarian Capsules',
      'Bacosides': 'Standardized to 20% Bacosides',
      'Part Used': 'Whole Plant',
      'Certification': 'USDA Organic'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/fade002ec6ef9f4e8d877c9d2a18a78dbf71c866e8cbbb319bb54c0c6a849440.png',
    featured: false
  },
  {
    id: 'tulsi-sleep-tea',
    name: 'Tulsi Sleep Tea',
    slug: 'tulsi-sleep-tea',
    category: 'stress-sleep',
    tagline: 'Calming Blend for Peaceful Nights',
    description: 'A soothing blend of Tulsi with calming herbs like Chamomile, Cardamom, and Ashwagandha. This caffeine-free tea helps prepare the body and mind for restful sleep.',
    benefits: [
      'Promotes relaxation before bed',
      'Caffeine-free formula',
      'Calms the nervous system',
      'Supports healthy sleep onset',
      'Pleasant, soothing taste'
    ],
    ingredients: ['Rama Tulsi', 'Krishna Tulsi', 'Chamomile Flowers', 'Cardamom', 'Ashwagandha Root', 'Peppermint'],
    usage: 'Steep 1 tea bag in hot water for 5-7 minutes. Enjoy 30-60 minutes before bedtime.',
    specifications: {
      'Pack Size': '25 Tea Bags',
      'Type': 'Caffeine-Free',
      'Flavor Profile': 'Floral, Earthy, Slightly Sweet',
      'Certification': 'USDA Organic'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/e474c67a968a4ebd09943670fb23135a59628f8eaa36504874b14f13d9f766eb.png',
    featured: false
  },
  {
    id: 'stress-relief-drops',
    name: 'Stress Relief Drops',
    slug: 'stress-relief-drops',
    category: 'stress-sleep',
    tagline: 'Fast-Acting Herbal Calm',
    description: 'Liquid herbal extract combining adaptogenic herbs for fast-acting stress relief. This convenient dropper formula provides quick support during stressful moments.',
    benefits: [
      'Fast-acting liquid formula',
      'Reduces stress and tension',
      'Supports emotional balance',
      'Convenient on-the-go use',
      'Non-drowsy formula'
    ],
    ingredients: ['Ashwagandha Extract', 'Holy Basil Extract', 'Lemon Balm Extract', 'Passionflower Extract', 'Vegetable Glycerin'],
    usage: 'Take 1-2 droppers (30-60 drops) under the tongue or in water, up to 3 times daily.',
    specifications: {
      'Pack Size': '60ml Dropper Bottle',
      'Type': 'Liquid Herbal Extract',
      'Alcohol': 'Alcohol-Free',
      'Certification': 'Non-GMO'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/aad938eaf39c60073c06244b802934c04d57e7ddaacb4b6bbab4ff3baee4d5d1.png',
    featured: false
  },

  // ENERGY & VITALITY
  {
    id: 'shilajit-resin',
    name: 'Shilajit Resin',
    slug: 'shilajit-resin',
    category: 'energy-vitality',
    tagline: 'Himalayan Mineral Pitch for Ultimate Vitality',
    description: 'ORIVANA Shilajit is pure, lab-tested resin sourced from high-altitude Himalayan rocks. This ancient mineral pitch contains over 84 minerals and fulvic acid for enhanced energy, strength, and rejuvenation.',
    benefits: [
      'Enhances energy and stamina',
      'Supports healthy testosterone',
      'Promotes cellular regeneration',
      'Rich in fulvic acid and minerals',
      'Supports cognitive function'
    ],
    ingredients: ['100% Pure Himalayan Shilajit Resin'],
    usage: 'Dissolve a pea-sized amount (300-500mg) in warm water or milk. Take once or twice daily.',
    specifications: {
      'Pack Size': '20g Glass Jar',
      'Purity': 'Gold Grade, 80%+ Fulvic Acid',
      'Altitude': 'Sourced above 16,000 feet',
      'Testing': 'Heavy Metal Tested'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/31ae388743504e00d4422cc68e99cc02c18b9a198267bd56ac08496dac837442.png',
    featured: true,
    isBestSeller: true
  },
  {
    id: 'moringa-capsules',
    name: 'Moringa Energy Capsules',
    slug: 'moringa-capsules',
    category: 'energy-vitality',
    tagline: 'Natural Energy Without Caffeine',
    description: 'Concentrated Moringa leaf extract providing natural, sustained energy without caffeine jitters. Rich in iron, B-vitamins, and plant protein for all-day vitality.',
    benefits: [
      'Sustained natural energy',
      'No caffeine crash',
      'Rich in iron for oxygen transport',
      'B-vitamins for metabolism',
      'Complete amino acid profile'
    ],
    ingredients: ['Organic Moringa Leaf Extract', 'Vegetable Cellulose Capsule'],
    usage: 'Take 2 capsules in the morning with breakfast.',
    specifications: {
      'Pack Size': '60 Vegetarian Capsules',
      'Extract Strength': '500mg per capsule',
      'Iron Content': '28% DV per serving',
      'Certification': 'USDA Organic, Vegan'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/6603d2d594be18f67a1a5095a9d18106fd51abb03bc1269ede674e46861fc506.png',
    featured: false
  },
  {
    id: 'gokshura-capsules',
    name: 'Gokshura Capsules',
    slug: 'gokshura-capsules',
    category: 'energy-vitality',
    tagline: 'Natural Performance Enhancer',
    description: 'Gokshura (Tribulus terrestris) is traditionally used in Ayurveda to support energy, stamina, and physical performance. ORIVANA Gokshura provides standardized extract for consistent benefits.',
    benefits: [
      'Supports physical endurance',
      'Promotes healthy hormone levels',
      'Enhances athletic performance',
      'Supports urinary tract health',
      'Natural energy booster'
    ],
    ingredients: ['Organic Gokshura Fruit Extract', 'Vegetable Cellulose Capsule'],
    usage: 'Take 1-2 capsules twice daily with meals.',
    specifications: {
      'Pack Size': '60 Vegetarian Capsules',
      'Saponins': 'Standardized to 40% Saponins',
      'Part Used': 'Fruit',
      'Certification': 'Non-GMO'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/3c8795d5b1faf2b99c3d1b00cce85b7bb3f379fecb47296beb6994c165fcc7cc.png',
    featured: false
  },

  // WOMEN'S WELLNESS
  {
    id: 'shatavari-capsules',
    name: 'Shatavari Capsules',
    slug: 'shatavari-capsules',
    category: 'womens-wellness',
    tagline: 'The Queen of Herbs for Women',
    description: 'Shatavari (Asparagus racemosus) is the premier Ayurvedic herb for women\'s health. ORIVANA Shatavari supports hormonal balance, reproductive health, and overall feminine wellness through all life stages.',
    benefits: [
      'Supports hormonal balance',
      'Promotes reproductive health',
      'Supports lactation in nursing mothers',
      'Helps manage menstrual discomfort',
      'Supports healthy menopause transition'
    ],
    ingredients: ['Organic Shatavari Root Extract', 'Vegetable Cellulose Capsule'],
    usage: 'Take 1-2 capsules twice daily with meals.',
    specifications: {
      'Pack Size': '60 Vegetarian Capsules',
      'Saponins': 'Standardized to 20% Saponins',
      'Part Used': 'Root',
      'Certification': 'USDA Organic'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/0d020e6c711538b16b6fbfa043025507a2c2f429feefefcc25407edf87154035.png',
    featured: true,
    isBestSeller: true
  },
  {
    id: 'womens-balance',
    name: "Women's Balance Formula",
    slug: 'womens-balance',
    category: 'womens-wellness',
    tagline: 'Comprehensive Hormonal Support',
    description: 'A specialized blend of Ayurvedic herbs formulated to support women\'s hormonal health. Combines Shatavari, Ashoka, and Lodhra for balanced menstrual cycles and reproductive wellness.',
    benefits: [
      'Supports regular menstrual cycles',
      'Helps reduce menstrual discomfort',
      'Promotes hormonal equilibrium',
      'Supports reproductive system health',
      'Calms mood fluctuations'
    ],
    ingredients: ['Shatavari Root', 'Ashoka Bark', 'Lodhra Bark', 'Aloe Vera', 'Dashamoola Blend'],
    usage: 'Take 2 capsules daily with meals, or as directed by healthcare provider.',
    specifications: {
      'Pack Size': '60 Vegetarian Capsules',
      'Type': 'Comprehensive Herbal Blend',
      'Form': 'Full Spectrum Extracts',
      'Certification': 'GMP Certified'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/c53d8a8011eccccc17e632da74786e1eee1b672b5752ce2eb20f0f2ee09f2f37.png',
    featured: false
  },
  {
    id: 'iron-complex',
    name: 'Plant-Based Iron Complex',
    slug: 'iron-complex',
    category: 'womens-wellness',
    tagline: 'Gentle Iron with Vitamin C',
    description: 'A gentle, non-constipating iron supplement made from whole food sources. Enhanced with natural Vitamin C from Amla for optimal absorption and utilization.',
    benefits: [
      'Gentle on the stomach',
      'Non-constipating formula',
      'Enhanced with Vitamin C for absorption',
      'Supports healthy hemoglobin levels',
      'Reduces fatigue and tiredness'
    ],
    ingredients: ['Curry Leaf Extract (Natural Iron)', 'Amla Extract (Vitamin C)', 'Moringa Leaf', 'Beetroot Powder'],
    usage: 'Take 1 capsule daily with food containing Vitamin C for best absorption.',
    specifications: {
      'Pack Size': '60 Vegetarian Capsules',
      'Iron Content': '18mg per capsule (100% DV)',
      'Type': 'Plant-Based, Whole Food',
      'Certification': 'Vegan, Non-GMO'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/cb6fce106244bcb49d16203135e807d5af65bfe8ee790470747d7c02be61f9da.png',
    featured: false
  },

  // MEN'S WELLNESS
  {
    id: 'mens-vitality',
    name: "Men's Vitality Formula",
    slug: 'mens-vitality',
    category: 'mens-wellness',
    tagline: 'Comprehensive Support for Active Men',
    description: 'A powerful blend of Ayurvedic herbs specifically formulated for men\'s health. Combines Ashwagandha, Shilajit, Safed Musli, and Gokshura for strength, stamina, and vitality.',
    benefits: [
      'Supports healthy testosterone levels',
      'Enhances strength and stamina',
      'Promotes muscle recovery',
      'Supports reproductive health',
      'Boosts energy and endurance'
    ],
    ingredients: ['Ashwagandha Root', 'Shilajit Extract', 'Safed Musli Root', 'Gokshura Fruit', 'Kapikacchu Seed'],
    usage: 'Take 2 capsules daily with meals, preferably in the morning.',
    specifications: {
      'Pack Size': '60 Vegetarian Capsules',
      'Type': 'Synergistic Herbal Blend',
      'Form': 'Standardized Extracts',
      'Certification': 'GMP Certified'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/82a46ef297bf431ea1b6f8350d6530a7d3a7893b363d2c4b1ba425903378df72.png',
    featured: true
  },
  {
    id: 'prostate-care',
    name: 'Prostate Care Capsules',
    slug: 'prostate-care',
    category: 'mens-wellness',
    tagline: 'Natural Prostate Support',
    description: 'ORIVANA Prostate Care combines traditional Ayurvedic herbs known to support prostate health and urinary function. Ideal for men over 40 seeking natural prostate support.',
    benefits: [
      'Supports healthy prostate size',
      'Promotes normal urinary flow',
      'Reduces nighttime urination',
      'Supports bladder comfort',
      'Natural, gentle formula'
    ],
    ingredients: ['Saw Palmetto Berry', 'Gokshura Fruit', 'Varuna Bark', 'Punarnava Root', 'Shilajit Extract'],
    usage: 'Take 2 capsules daily with meals.',
    specifications: {
      'Pack Size': '60 Vegetarian Capsules',
      'Type': 'Targeted Prostate Support',
      'Age Group': 'Recommended for men 40+',
      'Certification': 'Non-GMO'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/fe87cb0390741083429cba501e6bbf8c42113a60af2f5e0525935af64a5bf139.png',
    featured: false
  },
  {
    id: 'shilajit-mens',
    name: 'Shilajit Pure Resin',
    slug: 'shilajit-mens',
    category: 'mens-wellness',
    tagline: 'Himalayan Strength & Stamina Booster',
    description: 'ORIVANA Pure Shilajit Resin for men is sourced from pristine Himalayan altitudes above 16,000 feet. This ancient mineral pitch, rich in fulvic acid and 84+ trace minerals, has been used for centuries to enhance male vitality, strength, and overall physical performance.',
    benefits: [
      'Supports healthy testosterone levels naturally',
      'Enhances physical strength and endurance',
      'Promotes cellular energy and ATP production',
      'Supports muscle recovery after exercise',
      'Rich in fulvic acid for nutrient absorption'
    ],
    ingredients: ['100% Pure Himalayan Shilajit Resin'],
    usage: 'Dissolve a pea-sized amount (300-500mg) in warm water or milk. Take once in morning and once in evening for best results.',
    specifications: {
      'Pack Size': '30g Glass Jar',
      'Purity': 'Gold Grade, 82%+ Fulvic Acid',
      'Altitude': 'Sourced above 16,000 feet',
      'Testing': 'Heavy Metal & Purity Tested'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/79200c667a2732c30aade9b2a64becce27ea357a0c90a95265a21543314dba11.png',
    featured: true,
    isBestSeller: true
  },

  // JOINT & MOBILITY
  {
    id: 'joint-support',
    name: 'Joint Support Formula',
    slug: 'joint-support',
    category: 'joint-mobility',
    tagline: 'Flexibility and Comfort for Active Joints',
    description: 'A comprehensive formula combining traditional Ayurvedic herbs for joint health. Supports flexibility, comfort, and mobility for an active lifestyle.',
    benefits: [
      'Supports joint flexibility',
      'Promotes comfortable movement',
      'Supports healthy cartilage',
      'Reduces stiffness',
      'Supports active lifestyle'
    ],
    ingredients: ['Boswellia Serrata', 'Turmeric Extract (95% Curcuminoids)', 'Ashwagandha Root', 'Guggulu Resin', 'Ginger Root'],
    usage: 'Take 2 capsules twice daily with meals.',
    specifications: {
      'Pack Size': '60 Vegetarian Capsules',
      'Curcuminoids': '95% Standardized',
      'Boswellic Acids': '65% Standardized',
      'Certification': 'Non-GMO, GMP Certified'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/0c931e87e4819aa0adfc328bbaa5c8f87c4a9623471512045dfabb3eaa5f144b.png',
    featured: true,
    isNewArrival: true
  },
  {
    id: 'turmeric-curcumin',
    name: 'Turmeric Curcumin',
    slug: 'turmeric-curcumin',
    category: 'joint-mobility',
    tagline: 'Golden Root with Enhanced Absorption',
    description: 'High-potency turmeric extract standardized to 95% curcuminoids with black pepper extract for enhanced bioavailability. Supports healthy inflammatory response and joint comfort.',
    benefits: [
      'Powerful antioxidant support',
      'Supports healthy inflammation response',
      'Enhanced with BioPerine for absorption',
      'Supports brain health',
      'Promotes heart health'
    ],
    ingredients: ['Organic Turmeric Root Extract (95% Curcuminoids)', 'BioPerine Black Pepper Extract', 'Vegetable Cellulose Capsule'],
    usage: 'Take 1-2 capsules daily with a fat-containing meal.',
    specifications: {
      'Pack Size': '60 Vegetarian Capsules',
      'Curcuminoids': '500mg (95%) per capsule',
      'BioPerine': '5mg per capsule',
      'Certification': 'USDA Organic'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/8c1155a4ce9dde3e2201f1774812a44d64a7c35a858a22e31cc7e9a81a875b20.png',
    featured: false
  },

  // HEART HEALTH
  {
    id: 'arjuna-capsules',
    name: 'Arjuna Heart Support',
    slug: 'arjuna-capsules',
    category: 'heart-health',
    tagline: 'Ayurvedic Cardio-Tonic',
    description: 'Arjuna (Terminalia arjuna) bark has been used for centuries in Ayurveda to support heart health. ORIVANA Arjuna provides standardized extract for cardiovascular wellness.',
    benefits: [
      'Supports healthy heart function',
      'Promotes healthy blood pressure',
      'Supports healthy cholesterol levels',
      'Strengthens heart muscle',
      'Antioxidant protection for heart'
    ],
    ingredients: ['Organic Arjuna Bark Extract', 'Vegetable Cellulose Capsule'],
    usage: 'Take 1-2 capsules twice daily with meals.',
    specifications: {
      'Pack Size': '60 Vegetarian Capsules',
      'Arjunolic Acid': 'Standardized to 10%',
      'Part Used': 'Bark',
      'Certification': 'USDA Organic'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/24e357be6d3692ebb1a13760f3f4ff6b5fa8344733588c6a7c98baa9810dd1c1.png',
    featured: true
  },
  {
    id: 'omega-3-algae',
    name: 'Omega-3 Algae Oil',
    slug: 'omega-3-algae',
    category: 'heart-health',
    tagline: 'Plant-Based DHA & EPA',
    description: 'Sustainable, plant-based Omega-3 derived from microalgae. Provides essential DHA and EPA fatty acids for heart, brain, and eye health without fish or ocean pollution concerns.',
    benefits: [
      'Supports cardiovascular health',
      'Promotes brain function',
      'Supports eye health',
      'Sustainable and vegan',
      'No fishy aftertaste'
    ],
    ingredients: ['Microalgae Oil (Schizochytrium sp.)', 'Vegetable Softgel Capsule', 'Rosemary Extract (antioxidant)'],
    usage: 'Take 2 softgels daily with food.',
    specifications: {
      'Pack Size': '60 Vegan Softgels',
      'DHA': '250mg per serving',
      'EPA': '125mg per serving',
      'Certification': 'Vegan, Sustainable'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/399101e18d647fccace7f1abe5f03443a55c93add69fdd1c4b810ec7ff93bcf0.png',
    featured: false
  },
  {
    id: 'flaxseed-oil-capsules',
    name: 'Flaxseed Oil Capsules',
    slug: 'flaxseed-oil-capsules',
    category: 'heart-health',
    tagline: 'Plant-Based Omega-3 ALA Source',
    description: 'ORIVANA Flaxseed Oil Capsules provide a rich, vegetarian source of Omega-3 Alpha-Linolenic Acid (ALA) from cold-pressed organic flaxseeds. This essential fatty acid supports heart health, brain function, and helps maintain healthy cholesterol levels.',
    benefits: [
      'Rich source of Omega-3 ALA fatty acids',
      'Supports cardiovascular health',
      'Promotes healthy cholesterol levels',
      'Supports brain and cognitive function',
      'Nourishes skin, hair, and nails'
    ],
    ingredients: ['Cold-Pressed Organic Flaxseed Oil', 'Vegetarian Softgel Capsule', 'Vitamin E (natural preservative)'],
    usage: 'Take 2 softgels daily with meals. Can be taken with Omega-3 Algae Oil for comprehensive essential fatty acid support.',
    specifications: {
      'Pack Size': '90 Vegetarian Softgels',
      'ALA Content': '550mg per softgel',
      'Processing': 'Cold-Pressed, Unrefined',
      'Certification': 'USDA Organic, Non-GMO'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/fec1ff3fc80ebacf52e312e586bb10f12f1b21f8fc6df1cd69e530d778142109.png',
    featured: false,
    isNewArrival: true
  },

  // HERBAL TEAS
  {
    id: 'tulsi-original',
    name: 'Tulsi Original Tea',
    slug: 'tulsi-original',
    category: 'herbal-teas',
    tagline: 'Pure Triple Tulsi Blend',
    description: 'The original ORIVANA Tulsi tea featuring a harmonious blend of three sacred Tulsi varieties. Caffeine-free and perfect for daily wellness ritual.',
    benefits: [
      'Adaptogenic stress relief',
      'Supports respiratory health',
      'Rich in antioxidants',
      'Caffeine-free',
      'Calming yet energizing'
    ],
    ingredients: ['Rama Tulsi', 'Krishna Tulsi', 'Vana Tulsi'],
    usage: 'Steep 1 tea bag in hot water for 5-7 minutes. Enjoy multiple cups daily.',
    specifications: {
      'Pack Size': '25 Tea Bags',
      'Type': 'Caffeine-Free Herbal',
      'Flavor': 'Earthy, Slightly Spicy',
      'Certification': 'USDA Organic'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/7caee7375819ac24ab009d8f6ac0c8bf30dccee6b2a1e09c12166066697d2762.png',
    featured: true,
    isBestSeller: true
  },
  {
    id: 'tulsi-ginger',
    name: 'Tulsi Ginger Tea',
    slug: 'tulsi-ginger',
    category: 'herbal-teas',
    tagline: 'Warming Digestive Blend',
    description: 'A warming blend of Tulsi and organic ginger root. Perfect for digestive support, immune health, and cold weather comfort.',
    benefits: [
      'Supports healthy digestion',
      'Warming and comforting',
      'Soothes occasional nausea',
      'Immune system support',
      'Natural anti-inflammatory'
    ],
    ingredients: ['Rama Tulsi', 'Krishna Tulsi', 'Vana Tulsi', 'Organic Ginger Root'],
    usage: 'Steep 1 tea bag in hot water for 5-7 minutes. Add honey if desired.',
    specifications: {
      'Pack Size': '25 Tea Bags',
      'Type': 'Caffeine-Free Herbal',
      'Flavor': 'Spicy, Warming',
      'Certification': 'USDA Organic'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/84d20c8a5bf84710adad17f2a04030f40054ae2c516710200e09c77c1dc244cc.png',
    featured: false
  },
  {
    id: 'tulsi-green-tea',
    name: 'Tulsi Green Tea',
    slug: 'tulsi-green-tea',
    category: 'herbal-teas',
    tagline: 'Antioxidant-Rich Classic',
    description: 'Premium organic green tea infused with sacred Tulsi for a perfect balance of wellness and gentle energy. Rich in antioxidants and L-theanine.',
    benefits: [
      'Rich in antioxidants',
      'Gentle caffeine lift',
      'Supports metabolism',
      'Mental clarity and focus',
      'Combines benefits of green tea and Tulsi'
    ],
    ingredients: ['Organic Green Tea', 'Rama Tulsi', 'Krishna Tulsi', 'Vana Tulsi'],
    usage: 'Steep 1 tea bag in 80°C water for 3-5 minutes to avoid bitterness.',
    specifications: {
      'Pack Size': '25 Tea Bags',
      'Caffeine': 'Low (25-30mg per cup)',
      'Flavor': 'Grassy, Herbaceous',
      'Certification': 'USDA Organic'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/0b3bfc184a38b4340a976df1487df23e2af25d2ed0a32db369d63e583e5672f4.png',
    featured: true
  },
  {
    id: 'tulsi-lemon-ginger',
    name: 'Tulsi Lemon Ginger Tea',
    slug: 'tulsi-lemon-ginger',
    category: 'herbal-teas',
    tagline: 'Refreshing Immunity Boost',
    description: 'A zesty, refreshing blend of Tulsi, lemon, and ginger. Perfect for immune support, digestive comfort, and a refreshing pick-me-up any time of day.',
    benefits: [
      'Immune system support',
      'Digestive comfort',
      'Natural Vitamin C',
      'Refreshing hot or iced',
      'Energizing without caffeine'
    ],
    ingredients: ['Rama Tulsi', 'Krishna Tulsi', 'Vana Tulsi', 'Lemon Myrtle', 'Ginger Root', 'Lemongrass'],
    usage: 'Steep 1 tea bag for 5-7 minutes. Excellent hot or iced with honey.',
    specifications: {
      'Pack Size': '25 Tea Bags',
      'Type': 'Caffeine-Free Herbal',
      'Flavor': 'Citrusy, Zingy',
      'Certification': 'USDA Organic'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/207456d6a6f08619d7f9001909d8091e46b0aacf514841c1b5613db92babdde3.png',
    featured: false
  },
  {
    id: 'tulsi-masala-chai',
    name: 'Tulsi Masala Chai',
    slug: 'tulsi-masala-chai',
    category: 'herbal-teas',
    tagline: 'Traditional Indian Spiced Tea',
    description: 'An authentic masala chai experience with the added benefits of Tulsi. Organic Assam black tea blended with traditional chai spices for a rich, warming cup.',
    benefits: [
      'Traditional chai comfort',
      'Digestive spices',
      'Natural energy from black tea',
      'Warming and satisfying',
      'Perfect with milk'
    ],
    ingredients: ['Organic Assam Black Tea', 'Rama Tulsi', 'Cinnamon', 'Cardamom', 'Ginger', 'Cloves', 'Black Pepper'],
    usage: 'Steep 1 tea bag in hot water for 4-5 minutes. Add milk and sweetener to taste.',
    specifications: {
      'Pack Size': '25 Tea Bags',
      'Caffeine': 'Medium (40-50mg per cup)',
      'Flavor': 'Spicy, Rich, Aromatic',
      'Certification': 'USDA Organic'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/c78563027f7d9978664b53ac8c268ddf45992874295b0e33e375c6ff9b3cd283.png',
    featured: false
  },
  {
    id: 'chamomile-tea',
    name: 'Pure Chamomile Tea',
    slug: 'chamomile-tea',
    category: 'herbal-teas',
    tagline: 'Gentle Relaxation',
    description: 'Premium whole chamomile flowers for the ultimate relaxation tea. Naturally caffeine-free, this gentle tea promotes calm and supports restful sleep.',
    benefits: [
      'Promotes relaxation',
      'Supports restful sleep',
      'Soothes digestive discomfort',
      'Gentle and calming',
      'Perfect evening tea'
    ],
    ingredients: ['100% Organic Chamomile Flowers'],
    usage: 'Steep 1 tea bag in hot water for 5-7 minutes. Enjoy before bedtime.',
    specifications: {
      'Pack Size': '25 Tea Bags',
      'Type': 'Caffeine-Free',
      'Flavor': 'Floral, Honey-like, Gentle',
      'Certification': 'USDA Organic'
    },
    image: 'https://static.prod-images.emergentagent.com/jobs/eb4529a2-4ca6-41dd-a194-af190196c3ae/images/57ac25b81fb240b7c99c44b1a63b414adac279ba5c43faac7d77cfb413ebc829.png',
    featured: false
  }
];

export const getProductsByCategory = (categoryId) => {
  return wellnessProducts.filter(product => product.category === categoryId);
};

export const getProductBySlug = (slug) => {
  return wellnessProducts.find(product => product.slug === slug);
};

export const getFeaturedProducts = () => {
  return wellnessProducts.filter(product => product.featured);
};

export const getBestSellers = () => {
  return wellnessProducts.filter(product => product.isBestSeller);
};

export const getNewArrivals = () => {
  return wellnessProducts.filter(product => product.isNewArrival);
};

export const getCategoryById = (categoryId) => {
  return wellnessCategories.find(cat => cat.id === categoryId);
};
